import { incomeStore } from '@src/income/infra/stores';
import { incomeRepository } from '@src/income/infra/repositories';
import { get, writable } from 'svelte/store';
import { createIncomeDetails } from '@src/income/domain/factories/create-income-details.factory';
const repository = incomeRepository(incomeStore);
const income = writable(repository.getIncome());
const details = writable(repository.getDetails());
incomeStore.subscribe(({ context }) => {
    income.set(context.income);
    details.set(context.details);
});
export const useIncomeService = () => {
    const setFieldValue = (name) => (value) => {
        repository.setIncomeValue(name)(value);
    };
    const handleSubmit = () => {
        repository.setDetails(createIncomeDetails(get(income)));
    };
    return {
        setFieldValue,
        handleSubmit,
        income,
        details,
    };
};
